/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentitySettingsValidationData
 */
export interface IdentitySettingsValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentitySettingsValidationData
     */
    brandAndMarket?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentitySettingsValidationData
     */
    distributionChannel?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentitySettingsValidationData
     */
    agency?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentitySettingsValidationData
     */
    effectiveDates?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentitySettingsValidationData
     */
    timeout?: ValidationMessage;
}

export function IdentitySettingsValidationDataFromJSON(json: any): IdentitySettingsValidationData {
    return IdentitySettingsValidationDataFromJSONTyped(json, false);
}

export function IdentitySettingsValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentitySettingsValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
        'distributionChannel': !exists(json, 'distributionChannel') ? undefined : ValidationMessageFromJSON(json['distributionChannel']),
        'agency': !exists(json, 'agency') ? undefined : ValidationMessageFromJSON(json['agency']),
        'effectiveDates': !exists(json, 'effectiveDates') ? undefined : ValidationMessageFromJSON(json['effectiveDates']),
        'timeout': !exists(json, 'timeout') ? undefined : ValidationMessageFromJSON(json['timeout']),
    };
}

export function IdentitySettingsValidationDataToJSON(value?: IdentitySettingsValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
        'distributionChannel': ValidationMessageToJSON(value.distributionChannel),
        'agency': ValidationMessageToJSON(value.agency),
        'effectiveDates': ValidationMessageToJSON(value.effectiveDates),
        'timeout': ValidationMessageToJSON(value.timeout),
    };
}


